import { ChangeEvent, FormEvent, useState } from 'react';
import { useLang } from 'hooks/lang';

import { loaders } from 'entities';
import { useRouteParams } from 'routes';

import { Tag, Skeleton, Input, Column, Row, Label, Button } from 'components/Blocks';
import { CirclePlusIcon, PlusIcon } from 'components/Icons';

import { FormPieceProps } from './types';

export function SampleIds({ state, dispatch, isOpen }: FormPieceProps) {
  const { t } = useLang();
  const { projectId } = useRouteParams('projectProfile');

  const [owId, setOWId] = useState('');

  const { data: projectIds, loading } = loaders.projects.projectSampleIds.use({
    defaultValue: [],

    blockLoad: !isOpen,

    params: { projectId },
  });

  const add = (newId: string) => {
    dispatch({
      sampleIds: ({ sampleIds }) => {
        const duplicate = !!state.sampleIds.includes(newId);

        if (duplicate) return sampleIds;

        return [...sampleIds, newId];
      },
    });

    if (newId === owId) setOWId('');
  };

  const addDuo = (event: FormEvent) => {
    event.preventDefault();

    add(owId);
  };

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setOWId(target.value.trim());
  };

  const removeId = (idToRemove: string) => {
    dispatch({
      sampleIds: ({ sampleIds }) => sampleIds.filter((addedId) => addedId !== idToRemove),
    });
  };

  const btnBlocked = owId.length <= 2;

  return (
    <Column>
      <Label>{t('sample-ids')}</Label>

      <Row className="rounded-lg border bg-muted p-4">
        <Label className="text-sm">{t('ids-referenced-on-tasks')}:</Label>

        {loading ? (
          <Skeleton height={28} width={80} />
        ) : projectIds.length ? (
          <Row flexWrap="wrap" gap="2">
            {projectIds.map((addedId) => (
              <Tag
                key={addedId}
                name={addedId}
                color="primary"
                actionIcon={<PlusIcon size={14} />}
                action={state.sampleIds.includes(addedId) ? undefined : () => add(addedId)}
              />
            ))}
          </Row>
        ) : (
          <span className="text-sm italic">{t('no-ids-found-on-project')}</span>
        )}
      </Row>

      {!!state.sampleIds.length && (
        <Row flexWrap="wrap" gap="2">
          {state.sampleIds.map((addedId) => (
            <Tag
              size="medium"
              key={addedId}
              name={addedId}
              color="primary"
              action={() => removeId(addedId)}
            />
          ))}
        </Row>
      )}

      <form onSubmit={addDuo} className="relative">
        <Input value={owId} onChange={handleChange} placeholder={t('type-new-offerwise-id')!} />

        <Button
          variant="ghost"
          type="submit"
          disabled={btnBlocked}
          className="absolute right-1 top-1/2 -translate-y-1/2"
        >
          <CirclePlusIcon />
        </Button>
      </form>
    </Column>
  );
}
